import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

import Layout from "../components/common/Layout";
import { I18nContext } from "../i18n";
import MainPageEn from "../i18n/MainPage/en";
import MainPageFi from "../i18n/MainPage/fi";
import MainPageSv from "../i18n/MainPage/sv";

const MainPage = (props) => {
  const { dispatch } = useContext(I18nContext);
  const breadCrumbs = ["mainpage"];

  const contentLangs = { fi: MainPageFi, en: MainPageEn, sv: MainPageSv };
  const content = contentLangs[props.match.params.lang];

  document.title = content.title;
  useEffect(() => {
    if (props.match.params.lang !== "fi" && document.documentElement.lang !== props.match.params.lang) {
      document.documentElement.lang = props.match.params.lang;
      dispatch({ type: "setLanguage", payload: props.match.params.lang });
    }
    props.setActiveLink("Home");
  }, [dispatch, props]);

  return (
    <Layout breadCrumbs={breadCrumbs}>
      <main id="maincontent" tabIndex="-1">
        <div className="jumbotron jumbotron-flow-under">
          <Container>
            <h1>{content.header}</h1>
            <p className="lead">{content.description}</p>
          </Container>
        </div>
        <Container>
          {content.content.sections
            .filter((e) => !e.hidden)
            .map(({ title, lines, border }) => {
              return border ? (
                <section key={title.text} className="prh-section-borders">
                  {title?.url && (
                    <h2>
                      <Link to={title.url} href="#" target="_self">
                        {title.text}
                      </Link>
                    </h2>
                  )}
                  {title && !title.url && <h2>{title.text}</h2>}
                  {lines.map((line) => (
                    <p key={line} dangerouslySetInnerHTML={{ __html: line }} />
                  ))}
                </section>
              ) : (
                <div key={title.text} className="prh-section pt-2 pb-2 mt-2 mb-2">
                  {title?.url && (
                    <h2>
                      <Link to={title.url} href="#" target="_self">
                        {title.text}
                      </Link>
                    </h2>
                  )}
                  {title && !title.url && <h3>{title.text}</h3>}
                  {lines.map((line) => (
                    <p key={line} dangerouslySetInnerHTML={{ __html: line }} />
                  ))}
                </div>
              );
            })}
        </Container>
      </main>
    </Layout>
  );
};

export default withRouter(MainPage);
